<p-accordion [multiple]="multiple" class="file-info">
  <p-accordionTab [selected]="selected" [header]="header">
    <ng-content></ng-content>
  </p-accordionTab>
</p-accordion>
